import { makeAutoObservable } from 'mobx';
import { reaction, UiStateStore } from 'sdk';

import { ClientViewportStore } from './clientViewportStore';

export class DraggablePositionStore {
	public chatPos: Pos | null = null;
	private defaultChatPos: Pos | null = null;

	constructor(private viewPort: ClientViewportStore, private uiStore: UiStateStore) {
		makeAutoObservable(this);
		this.chatPos = this.uiStore.chatPos;

		reaction(
			() => [this.viewPort.height, this.viewPort.width],
			() => {
				this.resetPositions();
			}
		);

		reaction(
			() => this.uiStore.chatPos,
			(val) => {
				this.chatPos = val;
			}
		);
	}

	public setDefaultChatPos(pos: Pos): void {
		this.defaultChatPos = pos;
		if (!this.chatPos) {
			this.setChatPos(this.defaultChatPos);
		}
	}

	public setChatPos(pos: Pos): void {
		this.uiStore.setChatPos(pos);
	}

	private resetPositions(): void {
		this.defaultChatPos && this.setChatPos(this.defaultChatPos);
	}
}
